function env(name: keyof ImportMetaEnv): string | undefined {
  return import.meta.env[name] || undefined;
}

export const webConfig = {
  appScheme: env('VITE_APP_SCHEME') ?? 'tsuzuri',
  iosStoreUrl: env('VITE_IOS_STORE_URL'),
  androidStoreUrl: env('VITE_ANDROID_STORE_URL'),
  supportEmail: env('VITE_SUPPORT_EMAIL'),
  securityEmail: env('VITE_SECURITY_EMAIL'),
  legalOperatorName: env('VITE_LEGAL_OPERATOR_NAME'),
  legalAddress: env('VITE_LEGAL_ADDRESS'),
};
